export const actionTypes = {
  CHAGE: "CHANGE_PREVIEW_TEXT",
};

export const changePreviewText = (payLoad) => ({
  type: actionTypes.CHAGE,
  payLoad,
});
